import { Notifier } from '@airbrake/browser'
import Vue from 'vue'
const notAuthenticated = 'NOT_AUTHENTICATED'
const unknownUser = 'UNKNOWN_USER'
const isStaging = window.location.host === 'stagingvpc.goalbookapp.com'
const environment = isStaging ? 'staging' : process.env.NODE_ENV || 'development'
const projectId = process.env.VUE_APP_AIRBRAKE_PROJECT_ID
const projectKey = process.env.VUE_APP_AIRBRAKE_API_KEY
// Airbrake should not run if env variables are not present, or if Cypress is running
const allowAirbrake = projectId && projectKey && !window.Cypress

export const useAirbrake = router => {
    if (!allowAirbrake) {
        return router
    }

    const airbrake = new Notifier({
        environment,
        projectId,
        projectKey,
        keysBlocklist: ['password', 'password_confirmation']
    })

    airbrake.addFilter(notice => {
        if (notice.errors.some(error => error.message === 'Extension context invalidated.')) {
            return null
        }
        return notice
    })

    Vue.config.errorHandler = function (err, vm, info) {
        console.error(err)
        airbrake.notify({
            error: err,
            params: {info: info},
            context: {
            user: {
                id: unknownUser
            }
        }
      });
    }

    router.onError(err => {
        console.error(err)
        const appStore = router.app.$store
        const isAuthenticated = appStore.getters['user/isAuthenticated']
        const userId = isAuthenticated ? appStore.getters['user/userId'] : notAuthenticated
        const diagnostics = isAuthenticated ? appStore.getters['user/diagnostics'] : notAuthenticated
        airbrake.notify({
            error: err,
            context: {
            user: {
          id: userId,
        },
        diagnostics,
      },
    })
  })

    return router
}
